var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59953",
    "data-name": "Group 59953",
    transform: "translate(-13495 920)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16284",
    "data-name": "Rectangle 16284",
    width: 32,
    height: 32,
    transform: "translate(13495 -920)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Message",
    "data-name": "Iconly/Bold/Message",
    transform: "translate(13496.511 -917.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17218",
    "data-name": "Path 17218",
    d: "M22.013,0A7.451,7.451,0,0,1,29.47,7.441h0V19.082a7.452,7.452,0,0,1-7.457,7.441H7.456A7.451,7.451,0,0,1,0,19.082H0V7.441A7.442,7.442,0,0,1,7.456,0H22.013Zm1.667,7.662a1.12,1.12,0,0,0-.827.295h0l-6.644,5.3a2.308,2.308,0,0,1-2.947,0h0l-6.631-5.3A1.127,1.127,0,0,0,5.053,9.534h0l.193.192,6.7,5.231a4.64,4.64,0,0,0,5.76,0h0l6.647-5.319.118-.118a1.14,1.14,0,0,0-.016-1.474A1.239,1.239,0,0,0,23.679,7.662Z",
    fill: "#040403"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackmail);
export default __webpack_public_path__ + "static/media/blackmail.3bc7e12bb396495b9091c796491f6aff.svg";
export { ForwardRef as ReactComponent };